getCollapsedCategories = ->
  JSON.parse(localStorage.getItem('collapsed_categories') || "null") || ['Hidden', 'Скрытые']

class AccountCategory
  constructor: (obj) ->
    _.merge(@, obj)
    @id ||= uuidV4()
    @position ||= 0
    @name ||= ''
    @hidden = null # for now
    @collapsed = getCollapsedCategories().includes(@name)
    @selectable = true if _.isNil(@selectable)
    @position ||= 1000 if @name == 'Hidden' || @name == 'Скрытые'
    return @
  children: ->
    accs = HM.store.state.user.accounts.filter (tr) => tr.account_category ==  @id
    _.orderBy(accs, 'position', 'desc')
  @all: (categories = {}) ->
    categories = Object.values(categories)
    categories = _.map categories, (ac) -> new AccountCategory(ac)
    return categories

  toggle: ->
    @collapsed = !@collapsed
    collapsed_categories = HM.store.state.user.account_categories.filter (ac) => ac.collapsed
    localStorage.setItem('collapsed_categories', JSON.stringify(_.map(collapsed_categories, 'name')))

module.exports = AccountCategory
